/**
 * Our Play Store listing, for the /app and /download links (App.js). A
 * utm_source on the link (e.g. ?utm_source=share_page from the shared trip
 * page) is passed to Play as the install referrer, so Play Console can show
 * where installs came from. Only short [a-z0-9_] tags are passed on.
 */
export const PLAY_STORE_BASE = 'https://play.google.com/store/apps/details?id=in.mytownly.rides&pcampaignid=web_share';

export const playStoreUrl = (search = '') => {
  let source = '';
  try {
    source = new URLSearchParams(search).get('utm_source') || '';
  } catch {
    source = '';
  }
  if (!/^[a-z0-9_]{1,40}$/.test(source)) return PLAY_STORE_BASE;
  const referrer = `utm_source=${source}&utm_medium=web`;
  return `${PLAY_STORE_BASE}&referrer=${encodeURIComponent(referrer)}`;
};
